import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGoalSubgoalProgress } from 'shared/hooks/use-goal-subgoal-progress';
import { metricUnitFormatBase } from 'shared/types/metric-template';

import { InsightsCard } from './insights-card';
import { GoalInsightsCardProps } from './types';

export const GoalInsightsSubGoalCard: React.FC<GoalInsightsCardProps> = ({
  goal,
  startDate,
  endDate,
  ...rest
}) => {
  const { t } = useTranslation();
  const {
    entries,
    completionPercentage,
    completed,
    target,
    timeframeDifference,
  } = useGoalSubgoalProgress(goal, { startDate, endDate });

  const unitFormat = `${metricUnitFormatBase} ${t('general.labels.goal-progress.unit-format.sub-goals.label')}`;

  return (
    <InsightsCard
      goal={goal}
      startDate={startDate}
      endDate={endDate}
      {...rest}
      entries={entries}
      completionPercentage={completionPercentage}
      unitFormat={unitFormat}
      startValue={0}
      target={target}
      timeframeDifference={timeframeDifference}
      currentValue={completed}
    />
  );
};
